import { atom, useRecoilState } from 'recoil';

export type UseMarketingCampaignsSharedActionModals = {
  actionModal: ActionModal;
  selectedItems: any[];
  setActionModal: (action: ActionModal) => void;
  setSelectedItems: (items: any[]) => void;
};

export enum ActionType {
  EditTags = 'edit-tags',
}

type ActionModal = ActionType | null;

const marketingCampaignsActionModal = atom<ActionModal>({
  key: 'marketingCampaignsActionModal',
  default: null,
});

const marketingCampaignsSelectedItems = atom<any[]>({
  key: 'marketingCampaignsSelectedItems',
  default: [],
});

export function useMarketingCampaignsSharedActionModals(): UseMarketingCampaignsSharedActionModals {
  const [actionModal, setActionModal] = useRecoilState(marketingCampaignsActionModal);
  const [selectedItems, setSelectedItems] = useRecoilState(marketingCampaignsSelectedItems);

  return {
    actionModal,
    selectedItems,
    setActionModal,
    setSelectedItems,
  };
}
